import React from 'react'

import { SvgIcon } from '@mui/material'

export const path = `
  M4.47,20.50375
  L19.53,20.50375
  C21.07,20.50375 22.03,18.83375 21.26,17.50375
  L13.73,4.49375
  C12.96,3.16375 11.04,3.16375 10.27,4.49375
  L2.74,17.50375
  C1.97,18.83375 2.93,20.50375 4.47,20.50375 Z
  M12,13.50375
  C11.45,13.50375 11,13.05375 11,12.50375
  L11,10.50375
  C11,9.95375 11.45,9.50375 12,9.50375
  C12.55,9.50375 13,9.95375 13,10.50375
  L13,12.50375
  C13,13.05375 12.55,13.50375 12,13.50375 Z
  M13,17.50375
  L11,17.50375
  L11,15.50375
  L13,15.50375
  L13,17.50375 Z
`

export default props => (
  <SvgIcon {...props}>
    <path d={path} />
  </SvgIcon>
)
